/* Garage persistence + navbar picker takeover (Recipe 9, redesigned per 033).
   Cascade: Make → Generation → Year. Years are derived client-side from the
   generation's verified year_start/year_end (truck_year entries exceed Liquid's
   50-value cap). VIN mode: year from VIN char 10, generation matched by the
   engine char at the generation's vin_engine_position + year range.
   IDs and handles stay strings (HP2). Emits legacy GA4 names: select_truck. */
(function () {
  var COOKIE = 'tdt_truck';

  function lines() {
    var el = document.querySelector('[data-fitment-data]');
    try { return JSON.parse(el ? el.textContent : '[]') || []; } catch (e) { return []; }
  }
  /* Vehicle menu published by snippets/vehicle-menu-data (null when absent) */
  function vehicleMenu() {
    var el = document.querySelector('[data-vehicle-menu]');
    try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; }
  }
  /* "Ford" + "F-350" -> "Ford F-350"; "Dodge / Ram" + "Ram 3500" -> "Ram 3500"
     (the model already names the make, so it isn't repeated) */
  function vehicleName(make, model) {
    var first = String(model || '').split(' ')[0].toLowerCase();
    var makes = String(make || '').toLowerCase().split(/\s*\/\s*/);
    return makes.indexOf(first) > -1 ? model : (make + ' ' + model);
  }
  window.tdtVehicleName = vehicleName;
  function findGen(handle) {
    var out = null;
    lines().forEach(function (line) {
      (line.gens || []).forEach(function (gen) {
        if (gen.handle === handle) out = { line: line, gen: gen };
      });
    });
    return out;
  }

  window.tdtGarage = {
    /* extra: { ln: line handle, y: year number, yl: year label } — all optional.
       From the vehicle menu also: vy (year key), mk, md, bd (make / model / body
       keys, as in the menu and fitment_vehicles), bdl (body label), gn (group name). */
    set: function (handle, label, url, extra) {
      extra = extra || {};
      var ln = extra.ln;
      if (!ln) { var f = findGen(handle); if (f) ln = f.line.handle; }
      try {
        var payload = encodeURIComponent(JSON.stringify({
          h: handle, l: label, u: url || '', ln: ln || '',
          y: extra.y || null, yl: extra.yl || '',
          vy: extra.vy || '', mk: extra.mk || '', md: extra.md || '', bd: extra.bd || '', bdl: extra.bdl || '', gn: extra.gn || '', en: extra.en || ''
        }));
        document.cookie = COOKIE + '=' + payload + '; path=/; max-age=31536000; SameSite=Lax';
      } catch (e) {}
      if (window.dataLayer) window.dataLayer.push({ event: 'select_truck', truck_handle: handle, truck_label: label, truck_year: extra.y || null });
      render();
    },
    get: function () {
      try {
        var match = document.cookie.match(new RegExp(COOKIE + '=([^;]+)'));
        return match ? JSON.parse(decodeURIComponent(match[1])) : null;
      } catch (e) { return null; }
    },
    clear: function () {
      try { document.cookie = COOKIE + '=; path=/; max-age=0'; } catch (e) {}
      render();
    }
  };

  function prettify(handle) {
    return String(handle).replace(/-/g, ' ').toUpperCase();
  }
  function garageLabel(garage) {
    var base = garage.l || prettify(garage.h);
    return garage.yl ? base + ' \u00b7 ' + garage.yl : base;
  }
  /* Compact tag for the mobile chip: "{yy} {Make}" (e.g. "24 Cummins") */
  function garageLabelShort(garage) {
    var make = garage.mk || '';
    var f = make ? null : findGen(garage.h);
    if (f) make = f.line.mfr || String(f.line.title || '').split(' ')[0];
    if (!make) make = garage.l || prettify(garage.h);
    var yy = '';
    if (garage.y != null) yy = String(Math.floor(garage.y)).slice(-2) + ' ';
    return yy + make;
  }

  function render() {
    var garage = window.tdtGarage.get();
    document.querySelectorAll('[data-cc-garage-chip]').forEach(function (chip) {
      var label = chip.querySelector('[data-cc-garage-label]');
      var shortLabel = chip.querySelector('[data-cc-garage-label-short]');
      if (garage) {
        chip.classList.remove('is-hidden');
        if (label) label.textContent = garageLabel(garage);
        if (shortLabel) shortLabel.textContent = garageLabelShort(garage);
      } else {
        chip.classList.add('is-hidden');
      }
    });
    document.querySelectorAll('[data-cc-garage-swap]').forEach(function (swap) {
      swap.classList.toggle('is-hidden', !!garage);
    });
  }

  /* ---- Navbar picker takeover ---- */
  function initPicker() {
    var picker = document.querySelector('[data-truck-picker]');
    if (!picker) return;
    var cascadeMode = picker.querySelector('[data-picker-mode="cascade"]');
    var vinMode = picker.querySelector('[data-picker-mode="vin"]');
    /* Custom dropdown component (design: Picker Custom Dropdown) */
    function makeDD(root) {
      if (!root) return null;
      var btn = root.querySelector('[data-dd-btn]');
      var list = root.querySelector('[data-dd-list]');
      var valEl = root.querySelector('[data-dd-value]');
      var placeholder = root.dataset.ddPlaceholder || '';
      var dd = { value: '', options: [], onchange: null };
      function closeList() { list.classList.add('is-hidden'); btn.setAttribute('aria-expanded', 'false'); }
      function openList() {
        picker.querySelectorAll('[data-dd-list]').forEach(function (l) { if (l !== list) l.classList.add('is-hidden'); });
        picker.querySelectorAll('[data-dd-btn]').forEach(function (b) { if (b !== btn) b.setAttribute('aria-expanded', 'false'); });
        list.classList.remove('is-hidden');
        btn.setAttribute('aria-expanded', 'true');
        var sel = list.querySelector('.tdt-dd__opt--selected') || list.querySelector('.tdt-dd__opt');
        if (sel) sel.focus();
      }
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        if (list.classList.contains('is-hidden')) openList(); else closeList();
      });
      document.addEventListener('click', function (e) { if (!root.contains(e.target)) closeList(); });
      list.addEventListener('keydown', function (e) {
        var opts = Array.prototype.slice.call(list.querySelectorAll('.tdt-dd__opt'));
        var i = opts.indexOf(document.activeElement);
        if (e.key === 'ArrowDown') { e.preventDefault(); (opts[i + 1] || opts[0]).focus(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); (opts[i - 1] || opts[opts.length - 1]).focus(); }
        else if (e.key === 'Escape') { e.stopPropagation(); closeList(); btn.focus(); }
      });
      dd.fill = function (options) {
        list.innerHTML = '';
        dd.options = options || [];
        dd.options.forEach(function (o) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'tdt-dd__opt';
          b.setAttribute('role', 'option');
          if (o.sub) {
            /* Line name + the app's subtitle (the models it covers) */
            var t = document.createElement('span'); t.className = 'tdt-dd__opt-text';
            var l = document.createElement('span'); l.textContent = o.label;
            var s = document.createElement('span'); s.className = 'tdt-dd__opt-sub'; s.textContent = o.sub;
            t.appendChild(l); t.appendChild(s); b.appendChild(t);
          } else {
            b.textContent = o.label;
          }
          b.dataset.value = String(o.value);
          b.addEventListener('click', function () { dd.select(o.value); closeList(); btn.focus(); });
          list.appendChild(b);
        });
        btn.disabled = !dd.options.length;
        dd.value = '';
        valEl.textContent = placeholder;
        closeList();
      };
      dd.select = function (value, silent) {
        dd.value = String(value);
        var opt = dd.options.filter(function (o) { return String(o.value) === String(value); })[0];
        valEl.textContent = opt ? opt.label : placeholder;
        list.querySelectorAll('.tdt-dd__opt').forEach(function (b) {
          b.classList.toggle('tdt-dd__opt--selected', b.dataset.value === String(value));
        });
        if (!silent && dd.onchange) dd.onchange(dd.value, opt);
      };
      dd.selected = function () {
        return dd.options.filter(function (o) { return String(o.value) === dd.value; })[0] || null;
      };
      return dd;
    }
    /* Year → Make → Model → Body → Engine from the vehicle menu. A step is shown
       only with more than one choice; a single choice is taken automatically. */
    var menu = vehicleMenu();
    var STEPS = ['year', 'make', 'model', 'body', 'engine'];
    var dd = {};
    STEPS.forEach(function (s) { dd[s] = makeDD(picker.querySelector('[data-picker-step="' + s + '"]')); });
    var save = picker.querySelector('[data-picker-save]');
    var vinInput = picker.querySelector('[data-picker-vin-input]');
    var vinCheck = picker.querySelector('[data-picker-vin-check]');
    var vinMsg = picker.querySelector('[data-picker-vin-msg]');
    var strings = window.tdtPickerStrings || {};
    var choice = {};   /* year, make, model, body, group (index into menu.groups) */

    function open(mode) {
      /* The nav drawer overlays the header — close it so the picker is visible */
      var nd = document.getElementById('navDrawer');
      if (nd && !nd.hidden) {
        nd.classList.remove('nav-drawer--open');
        nd.hidden = true;
        document.documentElement.classList.remove('nav-drawer-lock');
        var t = document.getElementById('navMenuToggle');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
      picker.classList.remove('is-hidden');
      setMode(mode || 'cascade');
      preselect();
      var clearBtn = picker.querySelector('[data-picker-clear]');
      if (clearBtn) clearBtn.classList.toggle('is-hidden', !window.tdtGarage.get());
    }
    function close() { picker.classList.add('is-hidden'); }
    function setMode(mode) {
      if (cascadeMode) cascadeMode.classList.toggle('is-hidden', mode !== 'cascade');
      if (vinMode) vinMode.classList.toggle('is-hidden', mode !== 'vin');
      if (mode === 'vin' && vinInput) setTimeout(function () { vinInput.focus(); }, 60);
    }
    function field(step) { return picker.querySelector('[data-picker-field="' + step + '"]'); }
    function showField(step, on) { var f = field(step); if (f) f.classList.toggle('is-hidden', !on); }
    function keys(obj) { return obj ? Object.keys(obj) : []; }
    function node() {   /* the menu node for the current choice, or null */
      var n = menu && menu.years;
      for (var i = 0; i < 3; i++) {
        var k = [choice.year, choice.make, choice.model][i];
        if (k == null) return n;
        n = n && n[k];
      }
      return n;
    }
    function groupsFor() {
      var bodies = node();
      if (!bodies || choice.body == null) return [];
      return (bodies[choice.body] || []).slice();
    }
    function resetFrom(step) {
      var i = STEPS.indexOf(step);
      STEPS.slice(i).forEach(function (s) {
        if (s !== 'year') delete choice[s];
        if (s === 'engine') delete choice.group;
        if (dd[s]) dd[s].fill([]);
      });
      if (i <= STEPS.indexOf('body')) showField('body', false);
      showField('engine', false);
      if (save) save.disabled = true;
    }
    function fillYears() {
      if (!dd.year || !menu) return;
      dd.year.fill(keys(menu.years).sort(function (a, b) { return parseFloat(b) - parseFloat(a); })
        .map(function (y) { return { value: y, label: y }; }));
    }
    function afterYear() {
      resetFrom('make');
      var makes = keys(menu.years[choice.year]);
      dd.make.fill(makes.map(function (m) { return { value: m, label: m }; }));
      if (makes.length === 1) dd.make.select(makes[0]);
    }
    function afterMake() {
      resetFrom('model');
      var models = keys(menu.years[choice.year][choice.make]).sort();
      dd.model.fill(models.map(function (m) { return { value: m, label: m }; }));
      if (models.length === 1) dd.model.select(models[0]);
    }
    function afterModel() {
      resetFrom('body');
      var bodies = keys(node());
      var named = menu.bodies || {};
      dd.body.fill(bodies.map(function (b) { return { value: b, label: named[b] || b }; }));
      showField('body', bodies.length > 1);
      if (bodies.length === 1) dd.body.select(bodies[0]);
    }
    function afterBody() {
      resetFrom('engine');
      var gs = groupsFor();
      dd.engine.fill(gs.map(function (gi) { return { value: String(gi), label: (menu.groups[gi] || {}).n || String(gi) }; }));
      showField('engine', gs.length > 1);
      if (gs.length === 1) dd.engine.select(String(gs[0]));
    }
    if (dd.year) dd.year.onchange = function (v) { choice.year = v; afterYear(); };
    if (dd.make) dd.make.onchange = function (v) { choice.make = v; afterMake(); };
    if (dd.model) dd.model.onchange = function (v) { choice.model = v; afterModel(); };
    if (dd.body) dd.body.onchange = function (v) { choice.body = v; afterBody(); };
    if (dd.engine) dd.engine.onchange = function (v) { choice.group = parseInt(v, 10); if (save) save.disabled = !(choice.group >= 0); };

    function preselect() {
      if (!menu) return;
      if (!dd.year.options.length) fillYears();
      var g = window.tdtGarage.get();
      if (!g || !g.mk || !menu.years[g.vy]) return;
      var steps = [['year', g.vy], ['make', g.mk], ['model', g.md], ['body', g.bd]];
      for (var i = 0; i < steps.length; i++) {
        var d = dd[steps[i][0]];
        if (!d || !d.options.some(function (o) { return o.value === steps[i][1]; })) return;
        if (d.value !== steps[i][1]) d.select(steps[i][1]);
      }
      var gi = (menu.groups || []).map(function (x) { return x.h; }).indexOf(g.h);
      if (gi > -1 && dd.engine.options.some(function (o) { return o.value === String(gi); }) && dd.engine.value !== String(gi)) dd.engine.select(String(gi));
    }

    /* Save: the generation handle stays the garage key (truck pages, fit badge,
       pills); the menu choice rides along for the PDP fit check and the order's
       Vehicle line. */
    function saveVehicle() {
      var grp = menu && menu.groups[choice.group];
      if (!grp) return;
      var bodiesCount = keys(node()).length;
      var bodyLabel = (menu.bodies || {})[choice.body] || choice.body;
      /* The exact engine for this truck when the menu names one (e.g. L5D on a
         Silverado 4500 HD cab & chassis), instead of the group's "L5P/L5D" */
      var engineCode = (menu.engines || {})[[choice.year, choice.make, choice.model, choice.body].join('|')] || '';
      window.tdtGarage.set(grp.h, choice.year + ' ' + vehicleName(choice.make, choice.model), grp.u, {
        y: parseFloat(choice.year), yl: bodiesCount > 1 ? bodyLabel : '',
        vy: choice.year, mk: choice.make, md: choice.model, bd: choice.body, bdl: bodyLabel, gn: grp.n, en: engineCode
      });
      close();
      if (grp.u && window.location.pathname !== grp.u) window.location.href = grp.u;
    }
    if (save) save.addEventListener('click', saveVehicle);

    /* VIN mode saves by generation (a VIN doesn't name the model or body) */
    function saveTruck(genHandle, year, navigate) {
      var f = findGen(genHandle);
      if (!f) return;
      var extra = { ln: f.line.handle };
      if (year != null && year !== '') { extra.y = parseFloat(year); extra.yl = String(year); }
      window.tdtGarage.set(f.gen.handle, f.gen.label, f.gen.url, extra);
      close();
      if (navigate && f.gen.url && window.location.pathname !== f.gen.url) window.location.href = f.gen.url;
    }

    /* ---- VIN mode ---- */
    var translit = { A:1,B:2,C:3,D:4,E:5,F:6,G:7,H:8,J:1,K:2,L:3,M:4,N:5,P:7,R:9,S:2,T:3,U:4,V:5,W:6,X:7,Y:8,Z:9 };
    var weights = [8,7,6,5,4,3,2,10,0,9,8,7,6,5,4,3,2];
    function vinCheckDigit(vin) {
      var sum = 0;
      for (var i = 0; i < 17; i++) {
        var ch = vin[i];
        var val = /[0-9]/.test(ch) ? parseInt(ch, 10) : translit[ch];
        if (val == null) return false;
        sum += val * weights[i];
      }
      var rem = sum % 11;
      var expect = rem === 10 ? 'X' : String(rem);
      return vin[8] === expect;
    }
    /* VIN char 10 → model-year candidates (30-year cycle; both cycles kept,
       filtered to the range this catalogue can cover). */
    var yearCodes = 'ABCDEFGHJKLMNPRSTVWXY123456789';
    function yearCandidates(ch) {
      var idx = yearCodes.indexOf(ch);
      if (idx < 0) return [];
      return [1980 + idx, 2010 + idx].filter(function (y) { return y >= 1990 && y <= 2032; });
    }
    function vinResolve(vin) {
      var candidates = yearCandidates(vin[9]).sort(function (a, b) { return b - a; });
      var match = null;
      candidates.forEach(function (year) {
        if (match) return;
        lines().forEach(function (line) {
          if (match) return;
          (line.gens || []).forEach(function (gen) {
            if (match) return;
            var pos = parseInt(gen.vp, 10) || 8;
            var engineChar = vin[pos - 1];
            /* vin_engine_map first (a char with wmi needs a matching VIN prefix);
               generations without one use vin_engine_chars */
            var map = gen.vem;
            if (typeof map === 'string') { try { map = JSON.parse(map); } catch (e) { map = null; } }
            var engineOk;
            if (map && typeof map === 'object' && Object.keys(map).length) {
              var me = map[engineChar];
              engineOk = !!me && !(me.wmi && me.wmi.length && !me.wmi.some(function (w) { return vin.indexOf(w) === 0; }));
            } else {
              engineOk = (gen.vins || []).indexOf(engineChar) > -1;
            }
            /* Whole start year: a 2007.5 truck's VIN says 2007 (engine char tells it apart).
               Saved as the generation's own half year so it matches the picker's entry. */
            var ys = parseFloat(gen.ys);
            if (engineOk && year >= Math.floor(ys) && year <= parseFloat(gen.ye)) {
              match = { line: line, gen: gen, year: year < ys ? ys : year };
            }
          });
        });
      });
      return { match: match, years: candidates };
    }
    function setVinMsg(text, cls) {
      if (!vinMsg) return;
      vinMsg.textContent = text;
      vinMsg.classList.remove('is-error', 'is-ok');
      if (cls) vinMsg.classList.add(cls);
    }
    if (vinInput) vinInput.addEventListener('input', function () {
      vinInput.value = vinInput.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
      setVinMsg(strings.vinHint || '', null);
    });
    if (vinCheck) vinCheck.addEventListener('click', function () {
      var vin = (vinInput ? vinInput.value : '').toUpperCase();
      if (vin.length !== 17 || /[IOQ]/.test(vin) || !vinCheckDigit(vin)) {
        setVinMsg(strings.vinInvalid || '', 'is-error');
        return;
      }
      var res = vinResolve(vin);
      if (res.match) {
        setVinMsg((strings.vinMatch || '').replace('%t%', res.match.gen.label + ' · ' + res.match.year), 'is-ok');
        setTimeout(function () { saveTruck(res.match.gen.handle, res.match.year, true); }, 650);
      } else {
        setVinMsg((strings.vinNoMatch || '').replace('%y%', String(res.years[0] || '')), 'is-error');
      }
    });

    /* Triggers: any [data-picker-open], plus the #fitment hash from other pages */
    document.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-picker-open]') : null;
      if (t) { e.preventDefault(); open('cascade'); return; }
      var f = e.target.closest ? e.target.closest('a[href$="#fitment"]') : null;
      if (f) { e.preventDefault(); open('cascade'); return; }
      /* Build-kit CTAs: with a saved truck, land on that generation's
         collection pre-filtered to Bundles; without one, the link's own
         /collections/bundles target is fitment-gated anyway. */
      var bk = e.target.closest ? e.target.closest('[data-build-kit]') : null;
      if (bk) {
        var g = window.tdtGarage.get();
        if (g) {
          var fg = findGen(g.h);
          if (fg && fg.gen.col) {
            e.preventDefault();
            window.location.href = fg.gen.col + '?filter.p.product_type=' + encodeURIComponent('Bundles');
          }
        }
      }
    });
    picker.addEventListener('click', function (e) {
      if (e.target.closest('[data-picker-close]')) close();
      if (e.target.closest('[data-picker-vin-toggle]')) setMode('vin');
      if (e.target.closest('[data-picker-cascade-toggle]')) setMode('cascade');
      if (e.target.closest('[data-picker-clear]')) {
        window.tdtGarage.clear();
        resetFrom('make');
        if (dd.year) dd.year.select('', true);
        delete choice.year;
        e.target.closest('[data-picker-clear]').classList.add('is-hidden');
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !picker.classList.contains('is-hidden')) close();
    });
    if (window.location.hash === '#fitment') open('cascade');
  }

  /* ---- PLP fitment gate + garage filtering (cleanup-log 007) ---- */
  function initPlp() {
    var plp = document.querySelector('[data-plp]');
    if (!plp) return;
    var garage = window.tdtGarage.get();
    var gatePanel = plp.querySelector('[data-plp-gate-panel]');
    var body = plp.querySelector('[data-plp-body]');
    var garageBar = plp.querySelector('[data-plp-garage]');
    var params = new URLSearchParams(window.location.search);
    var showAll = params.get('show_all') === '1' || sessionStorage.getItem('tdt_show_all') === '1';

    if (garageBar && garage) {
      garageBar.classList.remove('is-hidden');
      var label = garageBar.querySelector('[data-plp-garage-label]');
      if (label) label.textContent = garageLabel(garage);
      var onlyMine = garageBar.querySelector('[data-plp-only-mine]');
      if (onlyMine) {
        var f = findGen(garage.h);
        if (f && f.gen.col) {
          var type = plp.getAttribute('data-plp-type') || '';
          onlyMine.href = f.gen.col + '?filter.p.product_type=' + encodeURIComponent(type);
          onlyMine.classList.remove('is-hidden');
        }
      }
    }

    if (plp.hasAttribute('data-plp-gate') && gatePanel && !garage && !showAll) {
      gatePanel.classList.remove('is-hidden');
      if (body) body.classList.add('plp__body--dimmed');
      var showAllBtn = plp.querySelector('[data-plp-show-all]');
      if (showAllBtn) {
        showAllBtn.addEventListener('click', function () {
          try { sessionStorage.setItem('tdt_show_all', '1'); } catch (e) {}
          gatePanel.classList.add('is-hidden');
          if (body) body.classList.remove('plp__body--dimmed');
        });
      }
    }

    var sort = plp.querySelector('[data-plp-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var p = new URLSearchParams(window.location.search);
        p.set('sort_by', sort.value);
        window.location.search = p.toString();
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    initPicker();
    initPlp();
    var genLanding = document.querySelector('[data-gen-landing]');
    if (genLanding) {
      var cur = window.tdtGarage.get();
      if (!cur || cur.h !== genLanding.dataset.genHandle) {
        window.tdtGarage.set(genLanding.dataset.genHandle, genLanding.dataset.genLabel, genLanding.dataset.genUrl);
      }
    }
    render();
  });
})();
